import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import styles from './Contact.module.scss'

interface Props {
  formId: string
}

const Contact: React.FC<Props> = ({ formId }) => {
  useHubSpotGenerate('na1', '9395227', `${formId}`, '#sp_hbspt')

  return (
    <div className={styles.contact_section} id="contact">
      <div className={styles.title}>
        <h3>お問い合わせ</h3>
        <p>は必須項目です</p>
      </div>
      <div className="services_hubSpot" id="sp_hbspt"></div>
    </div>
  )
}
export default Contact
